import { InMemoryCache } from 'apollo-cache-inmemory';
import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { createClient } from './Apollo';
import App from './App';
import { AuthContext, AuthService } from './AuthService';
import config from './config';
import { CookieNames } from './constants';
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV !== 'development') {
  document.addEventListener('DOMContentLoaded', () => {
    Sentry.init({
      dsn: 'https://83c466c0424c45cb85195ff02950c7cb@sentry.io/260079',
      environment: config.API_ENV,
    });
  });
}

const cache = new InMemoryCache().restore((window as any).__APOLLO_STATE__);
const client = createClient({
  cache,
  ssrMode: false,
  getAccessToken() {
    const cookies = new Cookies();
    return cookies.get(CookieNames.accessToken);
  },
});

hydrate(
  <AuthContext.Provider value={new AuthService()}>
    <Router>
      <App client={client} />
    </Router>
  </AuthContext.Provider>,
  document.getElementById('root')
);

if ((module as any).hot) {
  (module as any).hot.accept();
}
